<div class="logo-wrapper">
  <img
    [alt]="label()"
    [src]="brandLogo()"
    [style.width]="widthString() ? widthString() : null"
    [style.min-width.px]="widthString() ? minWidth() : null"
    [style.opacity]="opacity()"
    (load)="onImageLoaded($event)"
    [class.hasnt-width]="widthless()"
  />
</div>
